module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point2_5-0631995823b6037c1869480832546e1e.jpg";